import { combineReducers } from 'redux';

import user from './reducer/user';

const rootReducer = combineReducers({
	user,
});

export default rootReducer;
